const TASK_FIELD_DATE_TIME_FORMATTER = new Intl.DateTimeFormat('en-US', {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
})

export const formatTaskFieldDateTimeLabel = (value, fallbackLabel) => {
  if (!value) {
    return fallbackLabel
  }

  const parsedDate = new Date(value)

  if (Number.isNaN(parsedDate.getTime())) {
    return fallbackLabel
  }

  return TASK_FIELD_DATE_TIME_FORMATTER.format(parsedDate)
}

export const formatTaskFieldDateTimeForToast = (value) => {
  if (!value) {
    return null
  }

  const parsedDate = new Date(value)

  if (Number.isNaN(parsedDate.getTime())) {
    return null
  }

  return TASK_FIELD_DATE_TIME_FORMATTER.format(parsedDate)
}

export const toTaskDateTimeLocalValue = (value) => {
  if (!value) {
    return ''
  }

  const parsedDate = new Date(value)

  if (Number.isNaN(parsedDate.getTime())) {
    return ''
  }

  const year = parsedDate.getFullYear()
  const month = String(parsedDate.getMonth() + 1).padStart(2, '0')
  const day = String(parsedDate.getDate()).padStart(2, '0')
  const hours = String(parsedDate.getHours()).padStart(2, '0')
  const minutes = String(parsedDate.getMinutes()).padStart(2, '0')

  return `${year}-${month}-${day}T${hours}:${minutes}`
}

export const buildTaskPresetDate = (preset, hour, now = new Date()) => {
  const presetDate = new Date(now.getTime())

  if (preset === 'today') {
    presetDate.setHours(hour, 0, 0, 0)
    return presetDate
  }

  if (preset === 'tomorrow') {
    presetDate.setDate(presetDate.getDate() + 1)
    presetDate.setHours(hour, 0, 0, 0)
    return presetDate
  }

  if (preset === 'end_of_week') {
    const dayOfWeek = presetDate.getDay()
    const daysUntilFriday = dayOfWeek <= 5 ? 5 - dayOfWeek : 5

    presetDate.setDate(presetDate.getDate() + daysUntilFriday)
    presetDate.setHours(hour, 0, 0, 0)

    return presetDate
  }

  if (preset === 'next_week') {
    const dayOfWeek = presetDate.getDay()
    const daysUntilNextMonday = ((8 - dayOfWeek) % 7) || 7

    presetDate.setDate(presetDate.getDate() + daysUntilNextMonday)
    presetDate.setHours(hour, 0, 0, 0)

    return presetDate
  }

  return null
}
